import { queryOptions, useQuery } from '@tanstack/react-query';
import ms from 'ms';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import queryClient from '#/api/queryClient';

export type UseExternalUserInfoResponse = Awaited<
  ReturnType<typeof api.getIdentityUser>
>;

export function getExternalUserInfoQuery(opts: RequestOpts = {}) {
  const queryKey = ['getExternalUserInfo'];
  return queryOptions({
    queryKey,
    queryFn: ({ signal }) => {
      return api.getIdentityUser({
        ...opts,
        signal,
      });
    },
    staleTime: ms('1m'),
    gcTime: ms('5m'),
    initialDataUpdatedAt: queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
}

export async function fetchExternalUserInfoQuery(opts: RequestOpts = {}) {
  return queryClient.fetchQuery(getExternalUserInfoQuery(opts));
}

export function useExternalUserInfo(
  options: Omit<ReturnType<typeof getExternalUserInfoQuery>, 'queryKey'> = {},
) {
  const query = getExternalUserInfoQuery();
  return useQuery({
    ...query,
    staleTime: 0,
    ...options,
  });
}
